export default __webpack_public_path__ + "a1c09626c3188f16b5f84e2d26f3ec8d.png";